import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BB13ApplicationStatusInterface } from "../../models/interfaces/bb13ApplicationStatus.interface";

export interface BB13ApplicationsStates {
  bb13Applications: BB13ApplicationStatusInterface[];
}

const initialState: BB13ApplicationsStates = {
  bb13Applications: [],
};

const Bb13ApplicationsSlice = createSlice({
  name: "BB13 Applications",
  initialState,
  reducers: {
    updateBb13Applications: (
      state,
      action: PayloadAction<BB13ApplicationStatusInterface[]>
    ) => {
      state.bb13Applications = action.payload;
    },
  },
  extraReducers: {},
});

export const { updateBb13Applications } = Bb13ApplicationsSlice.actions;

export default Bb13ApplicationsSlice.reducer;
